"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolComponent = void 0;
const ArrowSymbol_1 = require("./symbolDefinitions/ArrowSymbol");
const CircleSymbol_1 = require("./symbolDefinitions/CircleSymbol");
const HexagonSymbol_1 = require("./symbolDefinitions/HexagonSymbol");
const RectangleSymbol_1 = require("./symbolDefinitions/RectangleSymbol");
const RocketSymbol_1 = require("./symbolDefinitions/RocketSymbol");
const StarSymbol_1 = require("./symbolDefinitions/StarSymbol");
const TriangleSymbol_1 = require("./symbolDefinitions/TriangleSymbol");
const symbolOrder = ['rectangle', 'triangle', 'circle', 'hexagon', 'star', 'arrow', 'rocket'];
var SymbolComponent;
(function (SymbolComponent) {
    SymbolComponent.type = 'symbol';
    function getSymbolArray() {
        return symbolOrder;
    }
    SymbolComponent.getSymbolArray = getSymbolArray;
    // Need a function for symbols with a fixed aspect ratio
    function symbolForName(name) {
        if (name === 'arrow')
            return ArrowSymbol_1.arrowSymbol;
        if (name === 'star')
            return StarSymbol_1.starSymbol;
        if (name === 'rectangle')
            return RectangleSymbol_1.rectangleSymbol;
        if (name === 'triangle')
            return TriangleSymbol_1.triangleSymbol;
        if (name === 'circle')
            return CircleSymbol_1.circleSymbol;
        if (name === 'hexagon')
            return HexagonSymbol_1.hexagonSymbol;
        if (name === 'rocket')
            return RocketSymbol_1.rocketSymbol;
        throw Error('missing def');
    }
    SymbolComponent.symbolForName = symbolForName;
    SymbolComponent.fillColors = [
        'none',
        'white',
        'brown-dark',
        'yellow',
        'pink',
        'blue',
        'green',
        'orange',
        'cyan',
        'black',
    ];
})(SymbolComponent || (exports.SymbolComponent = SymbolComponent = {}));
//# sourceMappingURL=SymbolComponent.js.map